<template>
  <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="task-title">
         {{ !taskTitle ? '配置任务包' : newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle }}
          <span v-if="taskTitle&&!disabled" @click="visible7=true;">修改</span>
      </div>
    </div>
    <template v-if="detail.approveVO && detail.approveVO.approveGuid">
      <div class="title">申请信息</div>
      <div class="approve-item-list">
        <div class="item">
          <div class="label">
            申请人：
          </div>
          <div class="value">
            {{ detail.approveVO.staffName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            所在部门：
          </div>
          <div class="value">
            {{ detail.approveVO.organisationName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            提交时间：
          </div>
          <div class="value">
            {{ detail.approveVO.createTime | getTimeDate }}
          </div>

        </div>
        <img v-if="detail.approveVO.approveState == 'C'" src="../../assets/images/ic_cancel.png" />
        <img v-if="detail.approveVO.approveState == 'Y'" src="../../assets/images/ic_pass.png" />
        <img v-if="detail.approveVO.approveState == 'A'" src="../../assets/images/ic_shenping.png" />
        <img v-if="detail.approveVO.approveState == 'R'" src="../../assets/images/ic_reject.png" />

      </div>

    </template>


    <div class="title">基本配置</div>
    <el-form label-width="100px" label-position="right" class="demo-ruleForm">
      <!-- 基本配置 开始 -->
      <div class="basic-conetent">
        <div style="display: flex; width: 800px">
          <!-- 任务类别 开始 -->
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务类别</span>
            <el-select @change="changeTaskCategory()" :disabled="isDisabled" v-if="!disabled" style="width: 300px; margin-left: 0px" v-model="taskCategory" filterable
              placeholder="请选择任务类别">
              <el-option v-for="item in getCodeListByKey('任务类别')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <div style="width: 300px; margin-left: 4px;text-align:left;" v-else>{{ getName(taskCategory, '任务类别') }}</div>
          </el-form-item>
          <!-- 任务类别 结束 -->

          <!-- 产品类别 开始 -->
          <el-form-item :style="disabled ? '' : 'margin-left:20px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">产品类别</span>
            <el-select multiple v-if="!disabled" :disabled="isDisabled" style="width: 300px; margin-left: 5px" v-model="productCategoryList" filterable
              placeholder="请选择产品类别">
              <el-option  v-for="item in getCodeListByKey('超级模版-对应产品类别')" :key="item.value" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
            <span v-else>{{ getName(productCategoryList, '超级模版-对应产品类别') }}</span>

          </el-form-item>
          <!-- 产品类别 结束 -->
        </div>
        <div style="display: flex">
          <!-- 项目运营人 开始 -->
          <div class="management-list" style="width: 400px">
            <div class="management-name"><span style="color: red">*</span>项目运营人</div>
            <div style="text-align: left" v-if="!isDisabled">
              <span class="designee" v-show="departmentData !== '' || departmentData !== null"
                v-for="(item, index) in departmentData" :key="index"><span class="select-name">{{ item.name
                }}</span>
                <span v-if="!disabled" @click="delDepartmentSingle(index)"
                  class="ml10 cursor-sty font-S19">×</span></span>
              <span class="select-department" v-if="!disabled" @click="addSchemPeople">{{
                departmentData && departmentData.length > 0 ? '修改' : '指定项目运营人'
              }}</span>
            </div>
            <div v-else style="text-align: left">
               <span class="designee" v-show="departmentData !== '' || departmentData !== null"
                v-for="(item, index) in departmentData" :key="index">
                <span class="select-name">{{ item.name }}</span>
              </span>
            </div>
          </div>
          <!-- 项目运营人 结束 -->

          <!-- 任务执行人 开始 -->
          <div class="base-info" :style="disabled ? '' : 'padding-left:20px;'">
            <div class="base-title"><span style="color: red">*</span>任务执行人</div>
            <div v-if="!isDisabled">
              <div class="depart-choose" @click="chooseDepartmentPerson" v-if="!disabled">
                <span v-if="departmentListII.length == 0" class="place-choose">请选择</span>
                <!-- <span class="place-show" v-else>{{ this.getDepartmentName(departmentListII) }}</span> -->
                <span class="place-show" v-else>{{ this.getDepartmentName(departmentListII) }}</span>
              </div>
              <div style="border: 0 none" class="depart-choose" v-else>{{ this.getDepartmentName(departmentListII) }}</div>
            </div>
            <div v-else>
                <span class="place-show">{{ this.getDepartmentName(departmentListII) }}</span>
            </div>
          </div>
          <!-- 任务执行人 结束 -->
        </div>
        <div style="display: flex;">
          <!-- 发布周期 开始-->
          <el-form-item :style="disabled ? 'padding-right:46px;' : 'padding-right:62px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">发布周期 </span>
            <div v-if="!isDisabled">
              <el-radio-group @change="month=null;year=null;timeRange=[];startTime=null;endTime=null;$forceUpdate();" v-model="taskReleaseCycleWay" :disabled="disabled">
                <el-radio label="按核算月">按核算月</el-radio>
                <el-radio label="按年">按年</el-radio>
                <el-radio label="自定义">自定义</el-radio>
              </el-radio-group>
            </div>
            <div v-else>
              <el-radio-group @change="month=null;year=null;timeRange=[];startTime=null;endTime=null;$forceUpdate();" v-model="taskReleaseCycleWay" :disabled="isDisabled">
                <el-radio label="按核算月">按核算月</el-radio>
                <el-radio label="按年">按年</el-radio>
                <el-radio label="自定义">自定义</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <!-- 发布周期 结束-->

          <!-- 执行日期 开始 -->
          <el-form-item style="width: 400px;"
            v-if="taskReleaseCycleWay == '按年' || taskReleaseCycleWay == '按核算月' || taskReleaseCycleWay == '自定义' || disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">执行日期 </span>
            <div :style="disabled ? '' : 'padding-left:4px'">{{ startTime || ' -' }} 至 {{ endTime || ' -' }}</div>
          </el-form-item>
          <!-- 执行日期 结束 -->
        </div>
        <div style="display: flex; width: 800px" v-if="!isDisabled">
          <!-- 选择时间 开始 -->
          <el-form-item style="width: 400px; padding-left: 20px" v-show="taskReleaseCycleWay == '自定义' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="timeRange" type="daterange" align="center" unlink-panels range-separator="至"
              start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd" style="width: 300px; float: left"
              :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px"  v-show="taskReleaseCycleWay == '按年' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="year" type="year" align="center" format="yyyy年" placeholder="请选择年份"
              style="width: 300px; float: left" value-format="yyyy" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px"  v-show="taskReleaseCycleWay == '按核算月' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="month" type="month" align="center" format="yyyy年MM月" placeholder="请选择核算月份"
              style="width: 300px; float: left" value-format="yyyyMM" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <!-- 选择时间 结束 -->

          <!-- 关联研发项目 开始 新增 or 详情页面   -->
          <template v-if="taskCategory == 1 && (isAdd || seeDetail)">
            <el-form-item  :class="disabled ? '' : 'ml20'" label-width="130px">
              <span slot="label"
               v-if="isAdd || seeDetail && projectList?.length"
              >
                关联研发项目
              </span>
              <el-select v-if="!disabled"  multiple collapse-tags class="w300" style="margin-left: -25px;" v-model="projectList" filterable placeholder="关联研发项目">
                <el-option v-for="item in projectOption" :key="item.guid" :label="item.name"
                  :value="item.guid"></el-option>
              </el-select>
               <div style="width: 300px; margin-left: 4px;text-align:left;" v-else>
                {{ formatListName() }}
               </div>
            </el-form-item>
          </template>
          <!-- 关联研发项目 结束 -->

          <!-- 所属企业 开始 -->
          <template v-if="taskCategory == 2">
            <el-form-item  :style="disabled ? '' : 'margin-left:20px'">
              <span slot="label" style="color: red">*</span>
              <span slot="label">所属企业</span>
              <el-select v-if="!disabled" style="width: 300px; margin-left: 4px" v-model="belongTenantGuid" filterable placeholder="所属企业">
                <el-option v-for="item in serviceTenantList" :key="item.guid" :label="item.tenantName"
                  :value="item.guid"></el-option>
              </el-select>
              <span v-else>{{belongTenantName }}</span>
            </el-form-item>
          </template>
          <!-- 所属企业 结束 -->

        </div>
        <div style="display: flex; width: 800px" v-if="taskCategory == 2">
          <!-- 任务类型 开始 -->
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务类型</span>
            <el-select v-if="!disabled" style="width: 300px;" v-model="isOfficialTask" filterable placeholder="请选择任务类型">
              <el-option v-for="(item, index) in isOfficialTaskList" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <div v-else style="width:300px;text-align:left;">{{ isOfficialTask=='Y'?'正式':'测试' }}</div>
          </el-form-item>
          <!-- 任务类型 结束 -->

          <!-- 关联研发项目 开始  新增 or 详情页面  -->
          <template v-if="isAdd || seeDetail">
            <el-form-item  label-width="130px" :style="disabled ? '' : 'margin-left:20px'">
              <span slot="label" 
                v-if="isAdd || seeDetail && projectList?.length"
              >
                关联研发项目
              </span>
              <el-select v-if="!disabled" multiple collapse-tags class="w300" style="margin-left: -25px;" v-model="projectList" filterable placeholder="关联研发项目">
                <el-option   v-for="item in projectOption" :key="item.guid" :label="item.name"
                  :value="item.guid"></el-option>
              </el-select>
              <div style="width: 300px; margin-left: 4px;text-align:left;" v-else>
                {{ formatListName() }}
              </div>
            </el-form-item>
          </template>
          <!-- 关联研发项目 结束 -->
        </div>
        <!-- 编辑时候 -->
        <div style="display: flex; width: 800px" v-if="isDisabled">
          <!-- 关联研发项目 开始 -->
          <template>
            <el-form-item  label-width="130px">
              <span slot="label">关联研发项目</span>
              <el-select  multiple collapse-tags style="width: 300px;margin-left: -25px;" v-model="projectList" filterable placeholder="关联研发项目">
                <el-option v-for="item in projectOption" :key="item.guid" :label="item.name"
                  :value="item.guid"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <!-- 关联研发项目 结束 -->
        </div>


      </div>
      <!-- 基本配置结束 -->

      <!--平台专属任务  明细开始 -->
      <div class="title padding0">任务明细</div>
      <TemplateConfig v-if="taskCategory==2" @delList="delWaitList" @delItem="delItem" @openTemplate="openTemplate"
         :disabled="disabled"  :configData="tableDataII" :startTime="startTime" :endTime="endTime" ref="templateConfig">
      </TemplateConfig>
      <!-- 平台专属任务 明细结束 -->


      <!--数据采集  明细开始 -->
      <DataTemplateConfig :class="iframeSh ? '': 'haveIf'" v-if="taskCategory==1" :configData="configDataObj" :disabled="disabled" :btnName="btnName" @countBtn="countBtn"  ref="dataTemplateConfig">

      </DataTemplateConfig>
      <!--数据采集  明细开始 -->

      <!-- 流程 开始 -->
      <div class="flow" v-if="isOfficialTask == 'Y'">
        <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
      </div>
      <!-- 流程结束 -->
      <div class="btn-groups submit-btn-box submit_btn_wrap">
        <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>

        <template v-if="isDisabled">
          <el-button class="btn-common btn-border-green" size="mini" type="info" @click="submitReq(0)"
          v-if="!disabled">保存，暂不提交</el-button>
        </template>
        <template v-else-if="taskCategory === '2'">
          <el-button class="btn-common btn-border-green" size="mini" type="info" @click="submitReq(0)"
          v-if="!disabled">保存，暂不提交</el-button>
        </template>
        <el-button class="btn-common" size="mini" type="info" @click="submitReq(1)" v-if="!disabled">{{ isOfficialTask ==
          'Y' ? '提交审核' : '提交' }}</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="toRevoke"
          v-if="disabled && detail.approveVO && detail.approveVO.approveState == 'A' && detail.approveVO.staffGuid == staffGuid">撤销</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="rejectDialogVisible = true"
          v-if="disabled && detail.approveVO && detail.approveVO.approveState == 'A' && detail.approveVO.approveStaffGuids.indexOf(staffGuid) > -1">驳回</el-button>
        <el-button class="btn-common" size="mini" type="info" @click="passDialogVisible = true"
          v-if="disabled && detail.approveVO && detail.approveVO.approveState == 'A' && detail.approveVO.approveStaffGuids.indexOf(staffGuid) > -1">通过</el-button>
      </div>
    </el-form>


    <!-- 选择项目运营人 开始 -->
    <el-dialog title="选择项目运营人" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input style="width:326px;" v-model="filterText" class="mt15" placeholder="请输入项目运营人"></el-input>
            <p style="margin:8px 0;" class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :filter-node-method="filterNodeDep"  :data="areaData" :show-checkbox="true" node-key="guid"
               ref="treeDep"
              @check-change="handleNodeClick1">
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img v-if="data.nodeType == 1" src="../../assets/images/ico_ora.png" alt="" />
                <img v-else src="../../assets/images/icon_per.png" alt="">
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChange1">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="name" label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择项目运营人 结束 -->

    <!--任务模版选择  开始  -->
    <el-dialog v-if="visible4" title="选择任务模版" :visible.sync="visible4" width="900px" center>
        <div class="search-row">
          <div class="search-col">
            <span class="search-name">任务名称：</span>
            <el-input v-model="superPage.taskContentName" style="width: 200px" placeholder="请输入任务名称"></el-input>
          </div>
          <div class="search-col">
            <span class="search-name">系统功能：</span>
            <el-input v-model="superPage.menuName" style="width: 200px" placeholder="请输入系统功能"></el-input>
          </div>
          <div class="search-col" style="margin-left: 20px">
            <el-button size="medium" type="info" @click="getSuperTemplateList(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="emptySearchSuper">清空</el-button>
          </div>
        </div>
        <el-table  border :data="superTemplateList" row-key="guid" ref="superTable"
          style="width: 100%;" @selection-change="handleSelectSuper" @row-click="handleClickSuper">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (superPage.pageIndex - 1) * superPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务名称" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="任务简述" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="tenantTaskNote" label="任务说明" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.tenantTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="goodsCategoryJson" label="产品类别" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{  getName(scope.row.goodsCategoryJson, '超级模版-对应产品类别') }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="系统功能" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.menuName }}{{ scope.row.menuRemark ? '（' + scope.row.menuRemark +
              ')' : ''
            }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="业务员报价" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskPrice }} {{ scope.row.taskPriceUnit }}</template>
          </el-table-column>
        </el-table>
        <el-pagination style="padding-bottom: 0 !important;text-align: center;" class="pt pb back-color-fff" background @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1" :page-sizes="[10, 100, 200]" :current-page="superPage.pageIndex"
          :page-size="superPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="superPage.totalRows">
        </el-pagination>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="cancelChooseTemplate">取消</el-button>
        <el-button size="medium" type="info" @click="sureChooseTemplate">确定</el-button>
      </div>
    </el-dialog>
    <!--任务模版选择  结束  -->

    <!-- 选择任务执行人 开始 -->
    <ChooseUser ref="chooseDepartment"  :belongStaffGuidList="departmentData" @onSelect="onDepartmentSelect"></ChooseUser>
    <!-- 选择任务执行人 结束 -->


    <!--修改任务包名 开始 -->
    <el-dialog title="修改任务包名称" :visible.sync="visible7" width="800px">
      <div class="title-memo">
        <div class="title-memo-title">
          <span style="color: red">*</span>
          <span style="font-weight:600">任务包名称: </span>
        </div>
        <div class="title-memo-label">{{ taskTitle }}</div>
        <el-input style="width: 290px;margin-left:10px;" type="text" :maxlength="8" placeholder="仅可输入8个字符"
          v-model="newTaskTitleTxt" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible7 = false;">取 消</el-button>
        <el-button size="medium" type="info" @click="sureModifyTaskName">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改任务包名 结束 -->


    <!-- 流程相关 开始  -->
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <!-- 流程相关 结束  -->


  </div>
</template>
  
<script>
import { bpmnroute } from '@/api/apiRoute';
import moment from 'moment';
import TemplateConfig from './components/TemplateConfig.vue';
import DataTemplateConfig from './components/DataTemplateConfig.vue';
import ChooseUser from './components/ChooseUser.vue';

export default {
  components: {
    DataTemplateConfig,
    ChooseUser,
    TemplateConfig
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo:userinfo,
      detailGuid:'', // 当前单的guid
      serviceTenantList:[],
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      iframeSh: false,
      iframeSrc: '',
      staffGuid: userinfo.staffGuid,
      btnName:'', // 计算/刷新 按钮
      taskReleaseCycleWay: '按核算月',
      timeRange: '',
      year: '',
      month: '',
      startTime: '',
      endTime: '',
      taskTitle: '',
      isOfficialTask: 'Y',//模版类型
      isOfficialTaskList: [{
        label: '正式',
        value: 'Y'
      }, {
        label: '测试',
        value: 'N'
      }],
      tenantName: '',
      templateGuid: '',
      superTemplateGuid: '',
      templateName: '',
      tenantList: [],
      templateList: [],
      tableDataII: [],
      superPage: {//超级模版请求参数
        isSuper: 'Y',
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizState: 'Y',
        taskContentName: null, //任务名称
        menuName: '', //菜单名称
      },
      superTemplateList: [], //超级模版列表
      templateSelectd: '', //被临时选中的项目模板
      chooseTemplate: '', //最终被选中的模版

      tableData: [],

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      fullscreenLoading: false,

      disabled: false,
      detail: {},

      visible4: false,
      activeTemlate: "0",

      departmentListII: [],

      tempSuperTemplate: [], //临时选中的超级模版

      newTemplateName: '',//模版名称

      organisationInfo: '', //执行部门
      orignTableII: [],

      visible7: false,
      newTaskTitleTxt: '',

      orderType: '1',
      isNextDay: false,
      nextDay: '',

      productCategoryList: [],//产品类别
      taskCategory: '2',//任务类别

      belongTenantGuid:null,//所属企业
      belongTenantName:null,

      configDataObj:null,
      isCalcflag:true,
      maxSum:'',
      projectOption: [],
      projectList: [],
    };
  },
  created() {
    // 获取关联研发项目
    this.getHeartProject()
    //获取超级运营结构
    this.getPlatformOrg();
    //获取服务商
    this.getServiceTenantList();
    //获取详情
    this.getDetail();
    this.btnName = this.$route.query.is_edit === '1' ? '刷新' : '计算'
  },
  watch: {
    orderType(newVal) {
      if (newVal == '2') {
        this.isNextDay = true;
        if (!this.$route.query.guid) {
          this.nextDay = 15;
        }
      } else {
        this.isNextDay = false;
        this.nextDay = '';
      }
    },
    nextDay(newVal) {
      if (newVal) {
        this.orderType = '2'
        this.isNextDay = true;
      }
    },
    timeRange(newVal) {
      if (!newVal) return;
      this.startTime = newVal[0];
      this.endTime = newVal[1];
    },
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    year(year) {
      if (this.disabled) return;
      if (!year) return;
      this.startTime = year + '-01-01';
      this.endTime = year + '-12-31';
    },
    month(month) {
      if (this.disabled) return;
      if (!month) return;
      //平台专属任务 获取当自然月起始日
      if (this.taskCategory == 2) {
        this.startTime = moment(month).startOf('month').format('YYYY-MM-DD')
        this.endTime = moment(month).endOf('month').format('YYYY-MM-DD')
      } else {
        let departmentListII = this.departmentListII;
        if (!departmentListII.length) {
          this.month = null;
          this.$message.error('请先选择任务执行人');
          return;
        }
        let tenantGuidList = [];
        departmentListII.forEach(item => {
          tenantGuidList.push(item.guid);
        })
        let req = tenantGuidList;
        this.api
          .postJson(`/${serverConfig.msConfigureService}/sysparameter/get-tenants/min-max-account-month?accountMonth=` + month, req)
          .then((resp) => {
            if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.startTime = this.$moment(resp.data.data[0]).format('YYYY-MM-DD');
              this.endTime = this.$moment(resp.data.data[1]).format('YYYY-MM-DD');
            } else {
              this.month = null;
              this.$message.error(resp.data.msg);
            }
          });
      }
    },
    //执行日期
    startTime(val) {
      if (val) {
        this.getTaskName();
        this.resetBtnName()
      }
    },
    //任务类别
    taskCategory(val) {
      if (val) {
        this.getTaskName();
      }
    },
    //任务类型
    isOfficialTask(val) {
      if (val) {
        this.getTaskName();
      }
    },
    //项目运营人
    departmentData:{
      deep: true,
      handler(val) {
        this.resetBtnName()
        if (!this.isDisabled && !this.seeDetail) {
          this.month = null
          this.year = null
          this.timeRange = []
        }
      },
    },
    //任务执行人
    departmentListII:{
      deep: true,
      handler(val) {
        this.resetBtnName()
      },
    },
    //产品类别
    productCategoryList:{
      deep: true,
      handler(val) {
        this.resetBtnName();
      },
    }
  },
  computed: {
    isAdd() {
      return this.$route.query.is_add
    },
    isDisabled() { // #数据采集类型禁用控制
      return this.$route.query.is_edit && this.taskCategory === '1' ? true : false
    },
    seeDetail() {
      return this.$route.query.is_detail
    }
  },
  methods: {
    getHeartProject() {
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/get-heart-project`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.projectOption = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    formatListName() { 
      if (!this.projectList?.length) {
        return '';
      }
      const newArr = this.projectOption.filter(item => this.projectList.includes(item.guid))
      if (newArr.length == 1) {
        return newArr[0].name;
      }
      const str = newArr.map(item => item.name).join('、')
      return str
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach(item => {
          list.forEach(el => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          })
        })
        return newArr.length ? newArr.join('、') : '-';

      } else {
        let lisArr = list.filter(item => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }

    },
    //获取服务商
    getServiceTenantList() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/select-service-tenants`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.serviceTenantList = res.data.data || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取任务包名称
    getTaskName() {
      if (!this.startTime) return;
      let taskTitle = `${this.getName(this.taskCategory, '任务类别')}${this.$moment(this.startTime).format('YYYY.MM.DD')}-${this.$moment(this.endTime).format('YYYY.MM.DD')}`
      this.taskTitle = taskTitle;
    },
    //修改任务包名
    sureModifyTaskName() {
      let taskTitle = `${this.getName(this.taskCategory, '任务类别')}${this.$moment(this.startTime).format('YYYY.MM.DD')}-${this.$moment(this.endTime).format('YYYY.MM.DD')}`
      this.taskTitle = taskTitle;
      this.visible7 = false;
    },
    delWaitList(guids) {
      guids.forEach(i => {
        this.tableDataII.forEach((j, k) => {
          if (i == j.guid) {
            this.tableDataII.splice(k, 1);
          }
        })
      })
    },
    delItem(index) {
      this.tableDataII.splice(index, 1);
    },
    handleSelectSuper(v) {
      this.tempSuperTemplate = v;
    },
    handleClickSuper(row, col, event) {
      row.flag = !row.flag;
      this.$refs.superTable.toggleRowSelection(row, row.flag);
    },
    openTemplate() {
      if (this.taskCategory == 2 && !this.productCategoryList.length) {
        this.$message.error('请先选择产品类别');
        return;
      }
      this.visible4 = true;
      this.getSuperTemplateList();
    },
    cancelChooseTemplate() {
      this.emptySearchSuper();
      this.visible4 = false;
    },
    //确定选中模版
    sureChooseTemplate() {
      if (!this.templateSelectd && this.tempSuperTemplate.length == 0) {
        this.$message.error('请选择模版');
        return;
      }
      //超级模版
      if (this.tableDataII.length == 0) {
        this.tableDataII = this.tempSuperTemplate;
        this.tableDataII.forEach((item, index) => {
          item.parentTemplateDetailName = item.taskContentName;
          item.parentTemplateDetailGuid = item.guid
        })
      } else {
        var tableData = this.$refs.templateConfig.tableData;
        this.tableDataII.forEach((item, index) => {
          if(tableData[index]){
            tableData[index].taskTotalOrigin = item.taskTotalOrigin;
          }
        })
        var tempSuperTemplate = this.tempSuperTemplate;
        tempSuperTemplate.forEach(item => {
          item.parentTemplateDetailName = item.taskContentName;
          item.parentTemplateDetailGuid = item.guid;
          tableData.push(item);
        })
        console.log(tableData)
        this.tableDataII = tableData;
      }
      this.orignTableII = this.tableDataII;
      this.templateGuid = this.superTemplateGuid;
      this.tempSuperTemplate = [];
  
      this.emptySearchSuper();
      this.visible4 = false;
    },
    handleSizeChange1(val) {
      let self = this;
      self.superPage.pageSize = val;
      this.getSuperTemplateList();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.superPage.pageIndex = val;
      this.getSuperTemplateList();
    },

    //获取超级模版
    getSuperTemplateList(type) {
      let self = this;
      if (type) {
        this.superPage = {
          isSuper: 'Y',
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          bizState: 'Y',
          taskContentName: !this.superPage.taskContentName ? null : Array.isArray(this.superPage.taskContentName) ? this.superPage.taskContentName : [this.superPage.taskContentName],
          menuName: this.superPage.menuName
        }
      }
      this.superPage.goodsCategoryJson = this.productCategoryList;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, this.superPage)
        .then((res) => {
          if (res.data.code != '00000') {
            this.$message.error(res.data.msg);
            return;
          }

          self.superTemplateList = res.data.data ? res.data.data.records : [];
          self.superPage.totalRows = res.data.data ? res.data.data.totalRows : 0
          self.superPage.totalPage = res.data.data ? res.data.data.totalPages : 0;
          if (!self.superTemplateList) return;
          self.superTemplateList.forEach(item => {
            item.taskTotalOrigin = item.taskTotal;
            this.superTemplateGuid = item.templateGuid;
            item.calcType = null;
            item.taskTotalType = null;
            item.goodsCategoryJson = item.goodsCategoryJson? JSON.parse(item.goodsCategoryJson):[];
          });
        });
    },
    //清空超级模版查询条件
    emptySearchSuper() {
      this.superPage = {
        isSuper: 'Y',
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizState: 'Y',
        taskContentName: null, //任务名称
        menuName: '', //菜单名称
      };
      this.getSuperTemplateList();
    },
    //选择发布人员
    addSchemPeople() {
      if (this.disabled) return;
      this.visible3 = true;
    },
    //获取任务包详情
    getDetail() {
      var self = this;
      if (!this.$route.query.guid) {
        this.getApprovalList();
        return;
      }
      if (this.$route.query.is_edit) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      var req = {
        guid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/platform-task/detail`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var detail = res.data.data;
          this.detail = res.data.data;
          if (localStorage.fromPath === '/platformTaskList') this.getApprovalList();
          var taskTitle = detail.taskTitle;
          var nextDay = detail.nextDay;
          var orderType = detail.orderType;
          var regex = /\((.+?)\)/g;
          this.taskReleaseCycleWay = detail.taskReleaseCycleWay;
       
          if (orderType == 1 || !orderType) {
            this.orderType = '1';
            this.isNextDay = false;
            this.nextDay = '';

          }
          if (orderType == 2) {
            this.orderType = '2';
            this.isNextDay = true;
            this.nextDay = nextDay;
          }
          this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
          this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
          this.taskCategory = detail.taskCategory;
          this.productCategoryList = detail.productCategoryList;
          this.belongTenantGuid = detail.belongTenantGuid;
          this.belongTenantName = detail.belongTenantName;
          this.tableDataII = detail.taskDetailList;
          this.departmentData = detail.projectManagerStaffList;
          this.departmentListII = detail.taskExecuteTenantList;
          this.projectList = detail.projectList?.map(item => item.guid) || [];
          detail.projectManagerStaffList.forEach(item=>{
            this.departmentList.push({
              name: item.name,
              guid: item.guid
            })
          })
          if (taskTitle.indexOf('(') > -1) {
            this.newTaskTitleTxt = taskTitle.match(regex)[0].replace("(", "").replace(")", "");
            this.taskTitle = taskTitle.split('(')[0];
          } else {
            this.taskTitle = taskTitle;
          }
          console.log(detail.taskCategory == 2)
          if (detail.taskCategory == 2) { //平台任务
            this.tableDataII.forEach(item => {
              if (item.taskTotalType == '固定量人均') {
                item.taskTotal = item.taskAvg;
              }
              if (item.surveyTenantGuid) {
                item.surveyObj = {
                  surveyTenantGuid: item.surveyTenantGuid,
                  surveyTitle: item.surveyTitle
                }
              }
            })
            var req = {
              taskID: this.$route.query.guid,
            };
            this.api.get(`/${serverConfig.msSalesPerformService}/task-set/template/get-template-detail-list`, req).then((res) => {
              this.tableDataII.forEach((i, j) => {
                res.data.data.forEach((k, l) => {
                  if (i.templateDetailGuid == k.guid) {
                    i.taskTotalOrigin = k.taskTotal;
                    i.guid = k.guid;
                    i.parentTemplateDetailName = k.parentTemplateDetailName || i.parentTemplateDetailName;
                    i.parentTemplateDetailGuid = k.parentTemplateDetailGuid || i.parentTemplateDetailGuid;
                  }
                })
              })
              this.orignTableII = this.tableDataII;
            });
          } else { //数据采集
            setTimeout(()=>{
              this.isCalcflag = false;
              this.configDataObj = {
              taskDetailList: detail.taskDetailList,
              taskAmountTotal: detail.taskAmountTotal,
              planCountTotal: detail.planCountTotal
            }
            },1000)
            this.getSumNum(detail.taskDetailList)
            this.$forceUpdate();
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSumNum(list){
      let maxSum = 0
      this.maxSum=''
      if(!list||list.length<1)return
      list.forEach(function(i){
        let sum = 0; 
        i.platformTaskDetailItemList.forEach(function(j){
            sum += j.taskExecuteStaffNum
            if (sum > maxSum) {
              maxSum = sum;
            }
                
          })
      })
      this.maxSum=maxSum&&maxSum>0?`服务人员共计${maxSum}人`:''
          
    },
    //确认发布
    async submitReq(type) {
      if (this.taskReleaseCycleWay == '自定义' && this.timeRange) {
        this.startTime = this.timeRange[0];
        this.endTime = this.timeRange[1];
      }
      if (this.disabled) return;
      let self = this;
      let isTips = [];
      if (!this.productCategoryList.length) {
        this.$message.error('请选择产品类别');
        return;
      }
      if (!this.departmentData.length) {
        this.$message.error('请选择项目运营人');
        return;
      }
      if(!this.departmentListII.length){
        this.$message.error('请选择任务执行人');
        return;
      }
      if (!this.startTime) {
        this.$message.error('请选择时间');
        return;
      }
      if (!this.belongTenantGuid &&this.taskCategory == 2) {
        this.$message.error('所属企业不能为空');
        return;
      }
      if (Array.isArray(this.tableDataII) && this.tableDataII.length == 0&&this.taskCategory == 2) {
        this.$message.error('请选择任务模版');
        return;
      }
      var detailParam = [];
      var projectManagerStaffList = this.departmentData;
      //平台专属任务
      if (this.taskCategory == 2) {
        var taskTotalUnitList = this.$refs.templateConfig.taskTotalUnitList;
        var tableDataII = this.$refs.templateConfig.tableData;
        try {
          tableDataII.forEach((el, orderIndex) => {
            var detail = {
              taskContentName: '', //任务名称名称
              taskContentGuid: '', //任务名称GUID
              taskContentType: '', //任务名称类别
              taskType: '', //任务大类
              taskTypeGuid: '', //任务大类Guid

              taskTotal: '', //任务总量
              taskTotalUnit: '', //任务总量单位
              taskTotalUnitGuid: '',

              taskPrice: '', //任务价格
              taskPriceUnit: '',
              taskPriceUnitGuid: '',

              menuUrl: '', //菜单地址
              taskContentJson: '',
              menuName: '', //菜单名称
              taskTotalType: '', //任务总量类型(????)


              staffWorkNote: '', //业务员工作要求
              staffTaskNote: '', //业务员任务文案
              tenantWorkNote: '', //药企工作要求
              tenantTaskNote: '', //药企任务文案
              countRule: '', //统计规则
              organisationInfo: null,
              clientObject: null, //客户对象json
              clientArea: '', //客户区域json
              clientAreaLabel: [],
              goodsInfo: '', //商品信息json
              taskIcon: '', //	string任务图标json

              settleRule: "1", //1单价 2比例
              settlePercent: null,

              isAskClock: '', //是否要求打卡 是/否
              isAskPhoto: '', //是否要求拍照 是/否
              minAskPhoto: '', //最少要求拍照数量
              isAskUpload: '', //是否要求上传资料 是/否
              minAskUpload: '', //最少上传资料数量

              isOpenMaxTask: 'Y', //是否开启超量上限拦截
              maxTaskValue: 0,  // 超量限制

              orderIndex: orderIndex + 1,
              templateDetailGuid: el.guid,
              isTeamLeader: '',
              isAllowTenantUse: '',
              menuRemark: '',
              parentTemplateDetailGuid: '',
              parentTemplateDetailName: '',

              taskLabel: ''
            };
            //根模版
            detail.parentTemplateDetailGuid = el.parentTemplateDetailGuid;
            detail.parentTemplateDetailName = el.parentTemplateDetailName;
            //任务大类
            detail.taskType = el.taskType;
            detail.taskTypeGuid = el.taskTypeGuid;

            if (!el.taskType && type == 1) {
              throw new Error('请选择任务大类');
            }
            //任务名称
            detail.taskContentGuid = el.taskContentGuid;
            detail.menuUrl = el.menuUrl;
            detail.taskContentJson = el.taskContentJson;

            //任务编码
            detail.taskCode = el.taskCode;
            //产品分类
            detail.goodsCategoryJson = typeof (el.goodsCategoryJson) == 'object' ? JSON.stringify(el.goodsCategoryJson) : el.goodsCategoryJson;
            //市场分类
            detail.marketingCategoryJson = el.marketingCategoryJson;

            detail.staffCategoryJson = el.staffCategoryJson;
            //任务中类
            detail.taskMediumType = el.taskMediumType;
            //是否常规任务
            detail.isNormalTask = el.isNormalTask;

            detail.isTeamLeader = el.isTeamLeader;
            detail.isAllowTenantUse = el.isAllowTenantUse;
            detail.menuName = el.menuName;
            detail.menuRemark = el.menuRemark;
            detail.taskContentType = el.taskContentType;
            detail.taskContentName = el.taskContentName;
            detail.clientObject = el.clientObject;
            if (!el.taskContentName && type == 1) {
              throw new Error('请选择任务名称');
            }


            detail.surveyTenantGuid = el.surveyObj && el.surveyObj.surveyTenantGuid || null;
            if (detail.menuUrl == '/subFillingApp/questionnaireFilling' && !detail.surveyTenantGuid) {
              throw new Error('请选择一个问卷');
            }

            detail.tenantTaskPrice = el.tenantTaskPrice;
            detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
            detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

            //业务员报价、业务员报价单位
            detail.taskPrice = el.taskPrice;
            detail.taskPriceUnit = el.taskPriceUnit;
            detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
            if (!el.taskPrice && type == 1) {
              throw new Error('请填写业务员报价');
            }
            if (!el.taskPriceUnitGuid && type == 1) {
              throw new Error('请填写业务员报价单位');
            }
            if (el.taskPriceUnit.indexOf(el.taskTotalUnit) == -1) {
              isTips.push(el.taskContentName);
            }

            //标准量、标准量单位
            detail.taskTotal = el.taskTotal;
            detail.taskTotalUnit = el.taskTotalUnit;
            detail.taskTotalUnitGuid = el.taskTotalUnitGuid;
            console.log('el.calcType',el);
            if (!el.calcType) {
              throw new Error('请选择计算方式');
            }
            if (el.calcType == '不限量') {
              detail.taskTotal = 0;
            }
            if (el.calcType != '不限量' && el.taskTotal == 0) {
              throw new Error('限量的任务量不能为0');
            }
            if (!el.taskTotal && (el.calcType == '固定量人均' || el.calcType == '系统计算')) {
              throw new Error('请填写任务量');
            }
            if (!el.taskTotalUnitGuid && type == 1) {
              throw new Error('请选择任务量单位');
            }

            if (el.isOpenMaxTask == 'Y') {
              if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
                detail.isOpenMaxTask = 'Y';
                detail.maxTaskValue = +el.maxTaskValue;
              } else {
                throw new Error('请填写正确上限百分比');
              }
            } else {
              detail.isOpenMaxTask = 'N';
              detail.maxTaskValue = 0;
            }

            detail.settleRule = el.settleRule;
            detail.settlePercent = el.settlePercent;

            detail.isAskClock = el.isAskClock;

            detail.isAskPhoto = el.isAskPhoto;
            detail.minAskPhoto = el.minAskPhoto;

            detail.isAskUpload = el.isAskUpload;

            detail.minAskUpload = el.minAskUpload;
            //任务要求
            detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

            //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
            detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
            detail.staffTaskNote = el.staffTaskNote;
            detail.tenantWorkNote = el.tenantWorkNote;
            detail.tenantTaskNote = el.tenantTaskNote;
            if (!el.tenantTaskNote && type == 1) {
              throw new Error('请至【更多内容编辑】中填写药企任务文案');
            }
            if (!el.staffTaskNote && type == 1) {
              throw new Error('请至【更多内容编辑】中填写运营方任务文案');
            }
            if (!el.staffWorkNote && type == 1) {
              throw new Error('请至【更多内容编辑】中填写运营方工作要求');
            }


            detail.clientArea = null;

            //商品
            detail.goodsInfo = null;

            //任务要求
            detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

            //任务图标
            detail.taskIcon = JSON.stringify(el.fileList);
            if (el.fileList && el.fileList.length == 0 && type == 1) {
              throw new Error('请至【更多内容编辑】中上传任务图标');
            }

            //规则
            taskTotalUnitList.forEach((item) => {
              if (item.guid == el.taskTotalUnitGuid) {
                detail.countRule = item.paramValue1;
              }
            });

            //任务总量类型
            detail.taskTotalType = el.calcType;

            detail.taskLabel = el.taskLabel && el.taskLabel.length ? JSON.stringify(el.taskLabel) : null


            detailParam.push(detail);
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        if (!this.isNextDay && this.orderType == 2) {
          this.$message.error('请勾选执行间隔');
          return;
        }
        if (!this.nextDay && this.orderType == 2) {
          this.$message.error('请填写间隔天数');
          return;
        }
      }
      //数据采集类
      if (this.taskCategory == 1) {
        detailParam = this.$refs.dataTemplateConfig.taskDetailList;
      }
      const ENV = location.href.indexOf('//scm-operation-pre-test.cs4pl.com') > -1 ? 'uat' : location.href.indexOf('https://scm-operation.csyaoly.com') > -1 ? 'pro' : location.href.indexOf('https://scm-operation.cs4pl.com') > -1 ? 'pre' : 'sit'
      const projectList = this.projectOption.filter(item => this.projectList?.includes(item.guid)) || [];
      let req = {
        taskDetailList: detailParam,//包明细
        taskTitle:  this.newTaskTitleTxt ? this.taskTitle + '(' + this.newTaskTitleTxt + ')' : this.taskTitle ,
        tenantName: (ENV == 'uat' || ENV == 'pre' || ENV == 'pro') ? '武汉链享医药供应链管理有限公司' : '武汉链享供应链科技有限公司 ',//超级运营公司名称
        tenantGuid: (ENV == 'uat' || ENV == 'pre' || ENV == 'pro') ? '89a3261c262411ebad37fa163e4b37cf' : '1aaf025422ff11eb9405080027ac9e40',//超级运营公司id
        isOfficialTask: this.isOfficialTask,
        taskCategory: this.taskCategory,
        productCategoryList: this.productCategoryList,//产品类别
        taskReleaseCycleWay: this.taskReleaseCycleWay,//发布周期
        taskExecuteTenantList: this.departmentListII,//任务执行企业
        startTime: this.startTime + ' 00:00:00',//开始时间
        endTime: this.endTime + ' 23:59:59',//结束时间
        isSendFlowFlag: type == 0 ? 'N' : 'Y',//任务包状态
        projectManagerStaffList,
        belongTenantGuid: this.belongTenantGuid,
        projectList,
        currentTenantGuid: localStorage.guid
      };
      if (this.taskCategory == 1 && type == 3 ) { // 触发数据采集的计算功能
        let param = JSON.parse(JSON.stringify(req))
        param.taskDetailList = []
        param.isSendFlowFlag = 'N'
        this.getResult(param) 
      } else if (this.taskCategory == 2 || this.taskCategory == 1) {
        let url = `/${serverConfig.msSalesPerformService}/platform-task/add`;
        let reqMethod = 'postJson'
        if (this.$route.query.guid) {
          req.guid = this.$route.query.guid;
          reqMethod = 'put';
          url = `/${serverConfig.msSalesPerformService}/platform-task/update`;
        } else {
          if (this.taskCategory == 1) { // !数据采集特殊逻辑
            if (!this.detailGuid) {
              this.$message.error('请先点击【计算/刷新】获取任务明细');
              return
            }
            req.guid = this.detailGuid
            reqMethod = 'put';
            url = `/${serverConfig.msSalesPerformService}/platform-task/update`;
          }
        }
        this.fullscreenLoading = true;
        self.api[reqMethod](url, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (type == 0) {
              self.$message.success('保存成功');
            } else {
              self.$message.success(this.$route.query.guid ? '重新提交成功' : '新增成功');
            }
            this.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }

    },
    chooseDepartmentPerson() {
      if(!this.departmentData.length) return this.$message.error('请先选择项目运营人')
      let departmentListII = this.departmentListII;
      let personList = [];
      if (!departmentListII.length) {
        sessionStorage.removeItem('selectNode') // 删除缓存
      }
      departmentListII.forEach(i => {
        personList.push(i.guid);
      });
      this.$refs.chooseDepartment.open(personList);
    },
    //获取人员部门名称
    getDepartmentName(list) {
      console.log('list', list)
      let sum = 0;
      list.forEach(item=>{
        if(item.desc){
          sum += +item.desc;
        }
      })
      return `服务人员共计${sum}人`;
    },
    //提交所选部门
    onDepartmentSelect([personGuidList, departmentData]) {
      
       this.departmentListII = departmentData;
       this.taskReleaseCycleWay = '按核算月';
    },
    //获取超级运营结构
    getPlatformOrg() {
      let self = this;
      const ENV = location.href.indexOf('//scm-operation-pre-test.cs4pl.com') > -1 ? 'uat' : location.href.indexOf('https://scm-operation.csyaoly.com') > -1 ? 'pro' : location.href.indexOf('https://scm-operation.cs4pl.com') > -1 ? 'pre' : 'sit'
      let query = {
        tenantGuid: (ENV == 'uat' || ENV == 'pre' || ENV == 'pro') ? '89a3261c262411ebad37fa163e4b37cf' : '1aaf025422ff11eb9405080027ac9e40',//超级运营公司名称
        staffType: '1'
      }
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            console.log(self.areaData)
           // this.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
    },
    treeData(areaData) {
      var self = this;
      const fn = (tree) => {
        tree.forEach(async (k) => {
          if (k.nodeType == 1) {
            k.disabled = true;
          }
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== '[]';
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              k.children = [...k.children];
              // 有子元素，需要调用自身
            }
          }
        });
      };
      fn(areaData);
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.treeDep.getCheckedNodes(true);
      this.$forceUpdate();
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //确定选择项目运营人
    departmentSure() {
      this.filterText = '';
      //任务执行人清空
      this.departmentListII = [];
      //执行日期清空
      this.startTime = null;
      this.endTime = null;
      this.taskReleaseCycleWay = '按核算月';
      this.departmentData = this.departmentList;
      this.visible3 = false;
    },
    //删除项目运营人
    delDepartmentSingle(index) {
      if (this.disabled) return;
      let arr = [];
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.departmentList.forEach(function (i, index) {
        arr.push(i.guid)
      });
      this.$refs.treeDep.setCheckedKeys(arr);
  
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选成员！');
        return;
      }
      let arr = [];
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }else{
            arr.push(i.guid)
          }
          self.$refs.treeDep.setCheckedKeys(arr);
        });
      });
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log( self.delList)
    },
    getApprovalList() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let token = localStorage.token;
      if (this.detail.approveVO && this.$route.query.guid && this.detail.approveVO.camundaInstanceId && this.detail.approveVO.camundaDeploymentId) {
        this.iframeSh = true;
        this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + this.detail.approveVO.camundaInstanceId + '&camundaDeploymentId=' + this.detail.approveVO.camundaDeploymentId + '&token=' + token;
        return;
      }
      let req = {
        tenantGuid: localStorage.guid,
        flowType: '00028',
        staffGuid: userinfo.staffGuid
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (!res.data.data) {
            this.$message.error('没有找到规则,请先联系运营人员设置当前部门的流程规则');
            this.iframeSh = false;
          } else {
            this.iframeSh = true;
            this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + res.data.data + '&token=' + token;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.detail.approveVO.approveGuid,
        flowType: '00028',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let query = {
        guid: this.detail.approveVO.approveGuid,
        flowType: '00028',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke() {
      let self = this;
      this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: this.detail.approveVO.approveGuid,
          flowType: '00028',
          approveStaffGuid: this.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //批量计算
    getResult(param) {
      if (this.btnName === '计算') {
        this.countHandle(param)
      } else if (this.btnName === '刷新') {
        this.refreshHandle(param)
      } 
    },
    // 计算方法
    countHandle(param) {
      if (this.$route.query.guid && this.isCalcflag) return;
      if (this.taskCategory != 1) return;
      if (!this.departmentData.length) return;
      if (!this.departmentListII.length) return;
      if (!this.startTime) return;
      this.fullscreenLoading = true;
      let req = {
        projectManagerStaffList: this.departmentData,
        taskExecuteTenantList: this.departmentListII,//任务执行企业
        startTime: this.startTime + ' 00:00:00',//开始时间
        endTime: this.endTime + ' 23:59:59',//结束时间
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/add-forecast-task`, param).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.btnName = '刷新'
          this.$message({
            showClose: true,
            message: '计算中，请稍后，可点击刷新按键获取最新结果',
            type: 'success',
            duration:5000
          });
        }
      })
    },
    // 刷新方法
    refreshHandle(param) {
      if (this.$route.query.guid && this.isCalcflag) return;
      if (this.taskCategory != 1) return;
      if (!this.departmentData.length) return;
      if (!this.departmentListII.length) return;
      if (!this.startTime) return;
      this.fullscreenLoading = true;
      let req = {
        projectManagerStaffList: this.departmentData,
        taskExecuteTenantList: this.departmentListII,//任务执行企业
        startTime: this.startTime + ' 00:00:00',//开始时间
        endTime: this.endTime + ' 23:59:59',//结束时间
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/get-forecast-task`, param).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let detail = res.data.data
          if (detail) {
            this.detailGuid = detail.guid
            this.btnName = '刷新'
             setTimeout(()=>{
                this.isCalcflag = false;
                this.configDataObj = {
                  taskDetailList: detail.taskDetailList,
                  taskAmountTotal: detail.taskAmountTotal,
                  planCountTotal: detail.planCountTotal
                }
              },1000)
              this.$forceUpdate();
              
              
          } else {
            this.$message.warning(res.data.msg)
          }
        } else {
          if (~res.data.msg.indexOf('计算失败，失败原因')) this.btnName = '计算'
          this.$message.error(res.data.msg)
        }
      })
    },
    // 触发计算保存按钮
    countBtn() {
      this.submitReq(3)
    },
    changeTaskCategory() {
      this.taskTitle=null;
      this.newTaskTitleTxt=null;
      this.isOfficialTask='Y';
      this.belongTenantGuid=null;
      this.startTime=null;
      this.endTime=null;
      this.year=null;
      this.month=null;
      this.timeRange=[];
      this.taskReleaseCycleWay = '按核算月';
    },
    getTaskGuid() {
      let param = {
        staffGuid: this.userinfo.staffGuid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskStartTime: this.startTime + ' 00:00:00',
        taskEndTime: this.endTime + ' 23:59:59',
        taskExecuteState: null,//执行状态
        stateList: [],//任务状态
        approveStateList: ['N'],//审批状态
        taskCategory: '1',//任务类别
        productCategoryList: this.productCategoryList,//产品类别
      }
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/platform-task/list`, param).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let list = res.data.data.records;
            if (Array.isArray(list) && list.length) {
              resolve(list[0])
            } else {
              resolve(null)
            }
          } else {
            resolve(null)
          }
         });
      })
    },
    resetBtnName() {
      if (!this.$route.query.is_edit) {
        this.btnName = '计算'
      }
    }
  },
};
</script> 
<style scoped>
.base-info label {
  width: 80px !important;
}
.title-memo {
  display: flex;
  align-items: center;

}

.title-memo .title-memo-title {
  display: flex;
  word-break: keep-all;
  flex-wrap: nowrap;
  margin-right: 10px;


}

.title-memo-label {
  max-width: 370px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.content {
  background: #fff;
  font-size: 18px;
}

/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

/deep/.el-form-item__content {
  margin-left: 20px !important;
}

.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}

.management-name {
  flex-shrink: 0;
  margin-right: 17px;
}

.designee {
  padding: 3px 6px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #deefef;
  border: 0 none;
  margin-bottom: 4px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding: 16px 0 10px 20px;
  margin-bottom: 0;
}


.template-box {
  width: 300px;
  float: left;
  border: 1px solid #dcdfe6;
  height: 34px;
  border-radius: 4px;
  line-height: 34px;
  text-align: left;
  text-indent: 10px;
  cursor: pointer;
  color: #606266;
}

.search-col {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.search-name {
  width: 80px;
  word-break: keep-all;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 20px 0;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 10px;
}

.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
  color: rgb(96, 98, 102);
}

.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 20px;
}

.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}

.place-show {
  padding-left: 20px;
  padding-right: 20px;
}

.ai-tips {
  height: 26px;
  background: #FFEEE3;
  color: #FF741E;
  line-height: 26px;
  font-size: 13px;
  padding-left: 10px;
}

.download-btns {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}

.ai-item .lable {
  font-size: 14px;
  color: #232323;
}

.ai-item {
  margin-top: 20px;
}

.ai-item .value {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other1 {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other2 {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.ai-item .ai-color {
  color: #4fa1a4;
  margin-left: 8px;
}


.download-btns .lable {
  font-size: 14px;
  color: #232323;
  flex: 1;
}

.download-btns .btns {
  flex: 1;
  display: flex;
  color: #323233;
  justify-content: flex-end;

}

.download-btns .btn1 {
  margin-right: 20px;
}

.download-btns .btn1,
.download-btns .btn2 {
  border: 1px solid #D9D9D9;
  padding: 6px;
  border-radius: 4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body {
  padding: 0 25px;
}

.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;

}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
  /* padding-right:20px; */
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.header .task-title {
  flex: 1;
  font-weight: 500px;
}

.header .task-title span {
  font-size: 12px;
  color: #4fa1a4;
  margin-left: 5px;
  cursor: pointer;
}

.basic-conetent {
  background: #fff;
  margin-bottom: 4px;
}

.btn-groups {
  background: #fff;
}

.btn-groups .btn-common {
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.btn-border-green {
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}

.btn-border-gray {
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0;
}

.padding0 {
  padding-bottom: 0;
}

.approve-item-list {
  display: flex;
  background: #fff;
  margin-bottom: 4px;
  align-items: center;
  padding-bottom: 16px;
  position: relative;
}

.approve-item-list .item {
  display: flex;
  margin-left: 40px;
}

.approve-item-list img {
  position: absolute;
  right: 40px;
  width: 70px;
  bottom: 8px;
}

.contract-name {
  word-break: keep-all;
  margin-right: 25px;
}
.haveIf {
  padding-bottom: 100px;
}
</style>
  
  